import React, {useEffect, useRef, useState} from 'react';
import ReactDOM from 'react-dom';

function ShopItem({shop}) {
    return (<div className="shop-item">
        <div>
            <div className="shop-categories">
                {
                    shop.shop_categories.map(function(category) {
                        return (<div style={{
                            color:category.color
                        }} key={category.id}>{category.description}</div>);
                    })
                }
            </div>
            <div className="title">
                {shop.title}
            </div>

            <div className="location">
                {shop.location.address}
            </div>

            <div className="description">
                {shop.description}
            </div>
        </div>
        <div className="shop-products">
            {
                shop.product_categories.map(function(category) {
                    return (<div key={category.id}>{category.title}</div>);
                })
            }
        </div>
    </div>)
}

export default React.memo(ShopItem);
